import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { GroupForm, CreateGroupFormData } from './GroupForm';
import { CreateGroupDto } from '@/lib/api/groups';

export interface CreateGroupModalProps extends BaseModalProps {
  onCreate: (data: CreateGroupDto) => Promise<boolean>;
  isCreating: boolean;
}

export function CreateGroupModal({
  open,
  onOpenChange,
  onCreate,
  isCreating,
}: CreateGroupModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: CreateGroupFormData) => {
    const success = await onCreate({
      name: data.name,
      description: data.description,
      isActive: true,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('groups.createModal.title')}>
      <GroupForm
        mode="create"
        onSubmit={handleSubmit}
        isLoading={isCreating}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
